import { AdviceArea } from '../constants/AdviceArea';

export const buildMessage = (adviceArea, data) => {
    let message = `Hello, \n\nI am looking for advice on ${AdviceArea[adviceArea]}. \n\n`;

    if (adviceArea === 392) {
        message += `The value of the property I'm looking to buy is ${data.mortgageValue}. \n\n`;
        message += `I have an annual income of ${data.annualIncome} `;
        message += `and a deposit of ${data.deposit}. \n\n`;
    } else {
        message += `I have ${data.wealthLevel} in savings, investments & pensions. \n\n`;
    }

    message += 'I am also keen to understand the costs associated with this advice.';
    return message;
};
